import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

interface MenuProps {
  selected?: string | number;
  options: {
    title: string;
    value: string | number;
  }[];
  className?: Partial<{
    wrapper: string;
    item: string;
  }>;
  onChange: (value: string | number) => void;
}

const DropdownMenu = forwardRef(({ selected, options, onChange, className }: MenuProps, ref: any) => {
  return (
    <div ref={ref} className={twMerge('dropdown-menu rounded-br-[12px] rounded-bl-[12px] dark:shadow-xl', className?.wrapper)}>
      {options.map(({ title, value }) => (
        <div
          key={value}
          className={twMerge('flex items-center desktop:font-light sm py-[12px] dark:text-white dark:hover:text-white', selected === value && 'text-secondary-400 dark:text-secondary-400', className?.item)}
          onClick={() => onChange(value)}
        >
          {title}
        </div>
      ))}
    </div>
  )
})


export default DropdownMenu;